import { reactive } from 'vue';

const resolucoes = {
    touch: {
        maxWidth:1023
    }
}

export const layoutStore = reactive({
    resolucaoTouch: false,
    
    verificaresolucaoTouch() {
        const displaySize = window.innerWidth;
        this.resolucaoTouch = displaySize <= resolucoes.touch.maxWidth;
        return this.resolucaoTouch;
    },
})